import {Component, inject} from '@angular/core';
import {ImageModule} from "primeng/image";
import {PanelModule} from "primeng/panel";
import {ButtonModule} from "primeng/button";
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {InputTextModule} from "primeng/inputtext";
import {SelectButtonModule} from "primeng/selectbutton";
import {AccordionModule} from "primeng/accordion";
import {CarouselModule} from "primeng/carousel";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  HousingOpportunitiesSearchComponent
} from "../../components/housing-opportunities-search/housing-opportunities-search.component";
import {RouterLink} from "@angular/router";
import {environment} from "../../../../environments/environment";
import {WhyCardComponent} from "./why-card/why-card.component";
import {NextHomeCardComponent} from "./next-home-card/next-home-card.component";
import {UserService} from "../../services/user.service";
import {ABService} from "../../services/a-b.service";
import {ReviewCarouselComponent} from "./review-carousel/review-carousel.component";
import {ApartmentService} from "../../services/apartment.service";
import {PaymentService} from "../../services/payment/payment.service";
import {SignupButtonComponent} from "../../components/signup-button/signup-button.component";
import {FullFooterComponent} from "../../components/full-footer/full-footer.component";
import {isNative} from "../../utils";
import {NgClass} from "@angular/common";
import {FadeInDirective} from "../../components/fade-in.directive";
import {NativeLandingComponent} from "./native-landing/native-landing.component";
import {UserEventsFeedComponent} from "./user-events-feed/user-events-feed.component";

@Component({
  standalone: true,
  imports: [
    ImageModule,
    PanelModule,
    ButtonModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    SelectButtonModule,
    AccordionModule,
    CarouselModule,
    ReactiveFormsModule,
    FormsModule,
    HousingOpportunitiesSearchComponent,
    RouterLink,
    WhyCardComponent,
    NextHomeCardComponent,
    ReviewCarouselComponent,
    SignupButtonComponent,
    FullFooterComponent,
    NgClass,
    FadeInDirective,
    NativeLandingComponent,
    UserEventsFeedComponent,
  ],
  templateUrl: './landing-page.component.html',
})
export class LandingPageComponent {
  private readonly userService = inject(UserService);
  private readonly apartmentService = inject(ApartmentService);
  private readonly paymentService = inject(PaymentService);
  private readonly abService = inject(ABService);

  protected readonly landingPageAboveFold = this.abService.landingPageAboveFold;
  protected readonly landingPageSectionOrder = this.abService.landingPageSectionOrder;
  protected readonly user = this.userService.user;
  protected readonly apartments = this.apartmentService.openLotteries;
  protected readonly freeTrialDuration = this.paymentService.freeTrialDuration;
  protected readonly textStyle = this.abService.textStyle;
  protected readonly eventFeed = this.abService.eventFeed;

  readonly faqs: { question: string, answer: string }[] = [
    {
      question: 'What is the NYC Housing Lottery?',
      answer: 'The NYC Housing Lottery is a city-run program that offers the chance to secure a brand-new, rent-stabilized apartment at an affordable rate.'
    }, {
      question: 'How much can I save on rent?',
      answer: 'Families typically save $1,000 to $1,200 per month compared to similar apartments. Plus, with rent-control, rent increases are limited to 2% annually.'
    }, {
      question: 'Do I qualify?',
      answer: 'The NYC Housing Lottery is open to a broad range of incomes, not just low-income households. Depending on the building, eligible incomes can be as high as $240,000 per year.'
    }, {
      question: 'What does Homey do?',
      answer: 'We\'re not affiliated with the city or the official lottery system. We just make the process easier by managing all the paperwork for you.'
    }, {
      question: 'What do I have to do?',
      answer: 'Getting started is easy! Share some basic details: income, family size, and housing preferences, and we’ll apply to all eligible lotteries for you in just 10–15 minutes.'
    }, {
      question: 'What happens to my Housing Connect account?',
      answer: 'Your existing Housing Connect account and any applications you’ve already submitted will remain unchanged. Homey doesn’t take over your account, we simply handle all your future applications for you.'
    }, {
      question: 'What happens if Homey messes up my application?',
      answer: 'Homey double-checks every application to ensure accuracy before submission. If there’s ever an issue, we’ll notify you and resolve it.'
    }
  ]

  protected readonly environment = environment;

  protected readonly yourDataButton = {
    root: {
      secondary: {
        background: '{text.color}',
        border: {
          color: '{text.color}'
        }
      }
    }
  };
  protected readonly isNative = isNative;
}
